<!--设置各列数据对应关系-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <!--        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row>
              <div class="searchStyle">
                <el-button type="primary" size="medium" plain @click="back">上一步</el-button>
                <el-button type="primary" size="medium" @click="nextStep">设置完毕,立即导入.</el-button>
              </div>
            </el-row>
          </div>
        </div> -->
        <div class="rowTipStyle" style="text-align: center;">
        </div>
        <div style="padding: 10px;">

          <div width="100%">
            <!-- <div style="text-align: center;font-size:20px;">表格基本信息</div> -->
            <div>
              <div style="font-size: 18px;font-weight: bold;">1.<span style="color:red;">*</span>请输入表格名称:</div>
              <div>
                <el-input v-model="form_name" placeholder="输入表格名称" style="width:50%"></el-input>
              </div>
            </div>
            <!--            <div style="margin-top: 20px;" v-if="import_data=='1'">
              <div style="font-size: 18px;font-weight: bold;"><span style="color:red;">*</span>选择读取数据的条件:</div>
              <div>
                <el-transfer v-model="selectedCondition" :data="transferList" :titles="['所有列名','查询条件']"></el-transfer>
              </div>
            </div> -->
            <!--            <div style="margin-top: 20px;">
              <div style="font-size: 18px;font-weight: bold;">2.<span style="color:red;">*</span>每人可填条数:</div>
              <div>
                <div>
                  <el-radio v-model="input_pages" label="1" border>每人只填一条</el-radio>
                  <el-radio v-model="input_pages" label="2" border>每人可填多条</el-radio>
                </div>
              </div>
            </div> -->
            <div style="margin-top: 20px;">
              <div style="font-size: 18px;font-weight: bold;">2.请输入领表说明:(选填)</div>
              <div>
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows:6 }" v-model="receive_notice"
                  placeholder="说明谁领表或什么情况下领表" style="width:40%"></el-input>
              </div>
            </div>
            <div style="margin-top: 20px;">
              <div style="font-size: 18px;font-weight: bold;">3.请输入填表必读:(选填)</div>
              <div>
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows:6 }" v-model="form_comment"
                  placeholder="说明填表时需要注意的事项" style="width:40%"></el-input>
              </div>
            </div>

            <div style="margin-top: 20px;" v-if="import_data=='1'">
              <div style="font-size: 18px;font-weight: bold;">
                4.预计可导入<span style="color:red;">{{dataList.length}}条</span>数据。
              </div>
            </div>

            <div style="padding: 10px;">
              <div class="actionBarStyle">
                <el-row>
                  <div class="searchStyle" v-if="import_data=='1'">
                    <!-- <el-button type="primary" size="medium" plain @click="back">上一步</el-button> -->
                    <el-button type="primary" size="medium" @click="nextStep">下一步</el-button>
                  </div>
                  <div class="searchStyle" v-else>
                    <!-- <el-button type="primary" size="medium" plain @click="back">上一步</el-button> -->
                    <el-button type="primary" size="medium" @click="nextStep">填写完毕,立即导入！</el-button>
                  </div>
                </el-row>
              </div>
            </div>

          </div>

        </div>

      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        username: '',
        form_name: '',
        form_comment: '',
        dataList: [],
        headList: [],

        transferList: [],
        selectedCondition: '',

        input_pages: '1',
        import_data: '',

        receive_notice: ''
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.dataList = JSON.parse(this.$route.params.dataList)
      this.headList = JSON.parse(this.$route.params.headList)
      this.import_data = this.$route.params.import_data

      this.transferList = []
      for (var i = 0; i < this.headList.length; i++) {
        let item = {
          key: this.headList[i].prop,
          label: this.headList[i].label,
          disabled: false
        }
        this.transferList.push(item)
      }

      console.log('this.transferList', this.transferList)
    },
    methods: {
      nextStep() {
        console.log(this.selectedCondition)
        if (Utils.isEmpty(this.form_name)) {
          this.$message.error('请输入表格名称')
          return
        }

        // if (this.import_data === '1' && Utils.isEmpty(this.selectedCondition)) {
        //   this.$message.error('请输入数据读取条件')
        //   return
        // }

        if (Utils.isEmpty(this.input_pages)) {
          this.$message.error('请选择每个人需要修正的数据条数')
          return
        }

        let that = this

        var requestUrl = '/form/web/_import_excel_form_data.jsp'
        // 开启loading

        let data = {
          username: that.username,
          form_name: that.form_name,
          form_comment: that.form_comment,
          receive_notice: that.receive_notice,
          head_list: JSON.stringify(that.headList),
          data_list: JSON.stringify(that.dataList),
          // condition_list: that.selectedCondition,
          input_pages: that.input_pages,
          import_data: that.import_data
        }

        // console.log('head_list====', that.headList)

        var qs = require('qs')

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: '正在导入,请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            // that.$message({
            //   duration: 5000,
            //   message: '导入成功！如需修改，请在微信中用多人填表修改！',
            //   type: 'success'
            // })
            load.close()

            if (that.import_data === '1') {
              // 判断是否有固定列数据
              var formId = response.data.form_id
              that.$router.push({
                name: 'set_valid_condition',
                params: {
                  form_id: formId,
                  form_name: that.form_name
                }
              })
            } else {
              that.$router.push({
                path: '/form_list',
                params: {
                  username: that.username
                }
              })
            }
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      back() {
        this.$router.back()
      },
      hasFixColumn() {
        let that = this
        var hasFixed = false

        for (var i = 0; i < that.headList.size(); i++) {
          let column = that.headList[i]
          if (column.can_edit == '0') {
            hasFixed = true
            break
          }
        }

        return hasFixed
      }

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .rowTipStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .settingRowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid aliceblue;
    margin: 5px;
  }

  .rowContentStyle {
    display: flex;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .settingFormStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .titleBarStyle {
    display: flex;
  }

  .columnTitleStyle {
    display: flex;
    flex-direction: column;
  }

  .colStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .paperShowStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/excel_data_import_final_step.vue